// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileSearchOutlinedSvg from "@ant-design/icons-svg/es/asn/FileSearchOutlined";
import AntdIcon from '../components/AntdIcon';

var FileSearchOutlined = function FileSearchOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileSearchOutlinedSvg
  }));
};

FileSearchOutlined.displayName = 'FileSearchOutlined';
export default React.forwardRef(FileSearchOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FileSearchOutlined.js
// module id = 1139
// module chunks = 0